module.exports = "<p>\n  recharge works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/recharge/recharge.component.html
// module id = ../../../../../src/app/recharge/recharge.component.html
// module chunks = main